import React, { useState, useEffect } from 'react';
import UserImg from '../../theme/assets/img/avatars/14.png';
import { store } from '../../app/store';
import { postAPI, postAPIForm, getURL } from '../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../store/hooks/Permission';

export default function Profile() {
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [TempFormData, setTempFormData] = useState({});
    const [Image, setImage] = useState("");
    const store_data = JSON.parse(store());
    const [API_URL, setAPIURL] = useState("");
    const [canView, setCanView] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const fetchURL = async () => {
        const URL = await getURL();
        setAPIURL(URL);
    };

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanEdit(true);
            } else {
                const viewAllowed = await hasPermission("GENERAL", "Profile", "VIEW");
                const editAllowed = await hasPermission("GENERAL", "Profile", "EDIT");
                setCanView(viewAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();
        setTempFormData({
            ...TempFormData, 
            account_status: store_data?.account_status ? 1 : 0,
            role: store_data?.role || '',
            user_unique_id: store_data?.user_unique_id || '',
            name: store_data?.name || '',
            email: store_data?.email || '',
            contact_number: store_data?.contact_number || '',
        })
        fetchURL();
    }, [])

    const handleChange = e => {
        const { name, value } = e.target;
        setTempFormData({
            ...TempFormData,
            [name]: value
        });
    }

    const handleUploadFile = async e => {
        if (!canEdit) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        setIsBTNClicked(true);
        if (IsBTNClicked) {
        } else {
            try {
                const file = e?.target?.files[0];
                if (!file) {
                    setIsBTNClicked(false);
                    alert('No file selected');
                    return;
                }
                console.log('Uploading file:', file);
                const formData = new FormData();
                formData.append('baseDir', 'Logo');
                formData.append('filename', file.name);
                formData.append('original_file', file);
                const data = await postAPIForm('/file/uploadFile', formData);
                if (data?.status === 0) {
                    setIsBTNClicked(false);
                    toast.error('Sorry ! Image not uploaded.');
                    return;
                }
                setImage(data.filepath);
                handleUpdateLogo(data.filepath)
                setIsBTNClicked(false);
            } catch (error) {
                setIsBTNClicked(false);
                console.error('File upload error:', error);
                toast.error('Sorry ! Image not uploaded.');
            }
        }
    }

    const handleUpdateLogo = async (image) => {
        setIsBTNClicked(true);
        if (IsBTNClicked) {
        } else {
            const filter = {
                username: store_data?.username,
                image: image
            }
            const response = await postAPI("/users/update-profile-picture", {...filter, user: store_data});
            if (response?.status) {
                setIsBTNClicked(false);
                toast.success('Great Job ! Your Image has been updated.');
                toast.warning('You will be logout in 10 sec to take affect in your profile.');
                setTimeout(()=> {
                    window.location.href = "/Logout";
                }, 10000)
            } else {
                setIsBTNClicked(false);
                toast.error('Sorry ! Image not uploaded.');
            }
        }
    }

    const handleUpdateAccountStatus = async () => {
        if (!canEdit) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        setIsBTNClicked(true);
        if (IsBTNClicked) {
        } else {
            setTempFormData({...TempFormData, status: !TempFormData?.account_status})
            const filter = {
                username: store_data?.username,
                status: !TempFormData?.account_status ? 1 : 0
            }
            const response = await postAPI("/users/toggleStatus", {...filter, user: store_data});
            if (response?.status) {
                setIsBTNClicked(false);
                toast.success('Great Job ! Your account has been deactivated.');
                toast.warning('You will be logout in 10 sec to take affect in your profile.');
                setTimeout(()=> {
                    window.location.href = "/Logout";
                }, 10000)
            } else {
                setIsBTNClicked(false);
                toast.error('Sorry ! Invalid Request. We cannot proceed with this request for now.');
            }
        }
    }

    const handleUpdateAccountInfo = async () => {
        if (!canEdit) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        setIsBTNClicked(true);
        if (IsBTNClicked) {
        } else {
            const filter = {
                username: store_data?.username,
                ...TempFormData
            }
            const response = await postAPI("/users/update", {...filter, user: store_data});
            if (response?.status) {
                setIsBTNClicked(false);
                toast.success('Great Job ! Your profile information has been updated.');
                toast.warning('You will be logout in 10 sec to take affect in your profile.');
                setTimeout(()=> {
                    window.location.href = "/Logout";
                }, 10000)
            } else {
                setIsBTNClicked(false);
                toast.error('Sorry ! Invalid Request. We cannot proceed with this request for now.');
            }
        }
    }

    return (
        <>
            <div class="container-xxl flex-grow-1 container-p-y">
                <h4 class="fw-bold py-3 mb-4"><span class="text-muted fw-light">Account Settings /</span> Account</h4>

                {!canView ? (
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <i className="ti ti-lock ti-lg text-danger mb-3" style={{fontSize: '3rem'}}></i>
                            <h4 className="text-danger mb-2">Access Denied</h4>
                            <p className="text-muted">You do not have permission to view this page.</p>
                        </div>
                    </div>
                ) : (
                <div class="row fv-plugins-icon-container">
                    <div class="col-md-12">
                        <ul class="nav nav-pills flex-column flex-md-row mb-4">
                            <li class="nav-item">
                                <a class="nav-link active" href="/Admin/Profile"><i class="ti-xs ti ti-users me-1"></i> Account</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/Admin/Security"><i class="ti-xs ti ti-lock me-1"></i> Security</a>
                            </li>
                            {/* <li class="nav-item">
                                <a class="nav-link" href="/Admin/Billing"><i class="ti-xs ti ti-file-description me-1"></i> Billing &amp; Plans</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/Admin/Notifications"><i class="ti-xs ti ti-bell me-1"></i> Notifications</a>
                            </li> */}
                        </ul>
                        <div class="card mb-4">
                            <h5 class="card-header">Profile Details</h5>
                            <div class="card-body">
                                <div class="d-flex align-items-start align-items-sm-center gap-4">
                                    {Image == "" ?
                                        <img src={store_data?.image ? `${API_URL}/${store_data?.image}` : UserImg} alt="user-avatar" class="d-block w-px-100 h-px-100 rounded" id="uploadedAvatar" />
                                        :
                                        <img src={`${API_URL}/${Image}`} alt="user-avatar" class="d-block w-px-100 h-px-100 rounded" id="uploadedAvatar" />
                                    }
                                    <div class="button-wrapper">
                                        <label for="upload" class="btn btn-primary me-2 mb-3 waves-effect waves-light" tabindex="0">
                                            <span class="d-none d-sm-block">Upload new photo</span>
                                            <i class="ti ti-upload d-block d-sm-none"></i>
                                            <input type="file" id="upload" class="account-file-input" onChange={handleUploadFile} hidden="true" accept="image/png, image/jpeg" />
                                        </label>
                                        <button type="button" class="btn btn-label-secondary account-image-reset mb-3 waves-effect">
                                            <i class="ti ti-refresh-dot d-block d-sm-none"></i>
                                            <span class="d-none d-sm-block">Reset</span>
                                        </button>

                                        <div class="text-muted">Allowed JPG, GIF or PNG. Max size of 800K</div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-0" />
                            <div class="card-body">
                                <form id="formAccountSettings" method="POST" onsubmit="return false" class="fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate">
                                    <div class="row">
                                        <div class="mb-3 col-md-6 fv-plugins-icon-container">
                                            <label for="role" class="form-label">Role</label>
                                            <input disabled={true} class="form-control" type="text" id="role" name="role" value={TempFormData?.role} autofocus="" />
                                            <div class="fv-plugins-message-container invalid-feedback"></div>
                                        </div>
                                        <div class="mb-3 col-md-6 fv-plugins-icon-container">
                                            <label for="user_unique_id" class="form-label">User Unique ID</label>
                                            <input disabled={true} class="form-control" type="text" name="user_unique_id" id="user_unique_id" value={TempFormData?.user_unique_id} />
                                            <div class="fv-plugins-message-container invalid-feedback"></div>
                                        </div>
                                        <div class="mb-3 col-md-12 fv-plugins-icon-container">
                                            <label for="name" class="form-label">Full Name</label>
                                            <input class="form-control" type="text" name="name" id="name" onChange={handleChange} value={TempFormData?.name} />
                                            <div class="fv-plugins-message-container invalid-feedback"></div>
                                        </div>
                                        <div class="mb-3 col-md-6">
                                            <label for="email" class="form-label">E-mail (Username)</label>
                                            <input class="form-control" disabled={true} type="text" id="email" name="email" onChange={handleChange} value={TempFormData?.email} placeholder="Enter Email ID" />
                                        </div>
                                        <div class="mb-3 col-md-6">
                                            <label class="form-label" for="contact_number">Phone Number</label>
                                            <div class="input-group input-group-merge">
                                                <span class="input-group-text">IN (+91)</span>
                                                <input type="text" id="contact_number" name="contact_number" onChange={handleChange} class="form-control" value={TempFormData?.contact_number} placeholder="Enter Phone Number" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        {canEdit && (
                                            <button type="button" class="btn btn-primary me-2 waves-effect waves-light" onClick={handleUpdateAccountInfo}>{IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>} Update</button>
                                        )}
                                        <button type="reset" class="btn btn-label-secondary waves-effect">Cancel</button>
                                    </div>
                                    <input type="hidden" /></form>
                            </div>
                        </div>
                        <div class="card">
                            <h5 class="card-header">Delete Account</h5>
                            <div class="card-body">
                                <div class="mb-3 col-12 mb-0">
                                    <div class="alert alert-warning">
                                        <h5 class="alert-heading mb-1">Are you sure you want to delete your account?</h5>
                                        <p class="mb-0">Once you delete your account, there is no going back. Please be certain.</p>
                                    </div>
                                </div>
                                <form id="formAccountDeactivation" onsubmit="return false" class="fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate">
                                    <div class="form-check mb-4">
                                        <input class="form-check-input" type="checkbox" name="account_status" id="account_status" checked={TempFormData?.account_status ? true : false} />
                                        <label class="form-check-label" for="account_status">I confirm my account deactivation</label>
                                        <div class="fv-plugins-message-container invalid-feedback"></div>
                                    </div>
                                    <label class="form-check-label" for="account_status">
                                        {canEdit && (
                                            <button type="button" class="btn btn-danger deactivate-account waves-effect waves-light" onClick={handleUpdateAccountStatus}>Deactivate Account</button>
                                        )}
                                    </label>
                                    <input type="hidden" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                )}
                <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
            </div>
        </>
    )
}
